import {all, put, takeLatest, takeLeading} from 'redux-saga/effects';
import {handleError, executeAxiosWithExceptionHandling, handleAxiosException} from "./index";
import { push } from 'connected-react-router';

import axios from "axios";


function* fetchRewardClaimHistory(action) {
	try {
		let response = yield executeAxiosWithExceptionHandling(() => axios.get(`/hotdeals/rest/rewards/${action.friendlyName}/history`));

		yield put({
			type: 'REWARD_CLAIM_HISTORY_FETCHED',
			rewardClaimHistory: response.data
		})
	} catch (error) {
		yield handleError(error);
	}
}

function* claimReward(action) {
	try {
		let response = yield axios.post(`/hotdeals/rest/rewards/${action.data.friendlyName}/claim?amount=${action.data.amount}`);

		yield put({
			type: 'REWARD_CLAIMED'
		})

		yield put(push(`/order/${response.data.orderId}`))

	} catch (exception) {
		let friendlyName = action.data.friendlyName;
		if (exception && exception.response && exception.response.status === 404) {
			yield put({ type: 'REWARD_NOT_FOUND' })
		}else if (exception && exception.response && exception.response.status === 420)  {
			yield put({ type: 'ACCOUNT_LIMIT_EXCEEDED', friendlyName})
		}else if (exception && exception.response && exception.response.status === 421)  {
			yield put({ type: 'REWARD_OUT_OF_STOCK', friendlyName})
		}else if (exception && exception.response && exception.response.status === 422)  {
			yield put({ type: 'REWARD_NOT_ACTIVE'})
		}else if (exception && exception.response && exception.response.status === 424)  {
			yield put({ type: 'INVALID_AMOUNT'})
		}else{
			handleAxiosException(exception);
		}
	}
}

export default function* rewardClaimsSaga() {
	yield all([
		takeLatest(['FETCH_REWARD_CLAIM_HISTORY', 'ACCOUNT_LIMIT_EXCEEDED', 'REWARD_OUT_OF_STOCK'], fetchRewardClaimHistory),
		takeLeading('CLAIM_REWARD', claimReward)
	]);
}